// extracted by mini-css-extract-plugin
export default {"root":"LocationDetails_root__H+e+i","field":"LocationDetails_field__Tf0pA"};